import React, {Component} from 'react';
import {Row, Col, Card, } from 'react-materialize';
import Home from '../../components/home/home';

import youtube from '../../images/youtube.png';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {injectIntl, intlShape} from 'react-intl';

import YouTube from 'react-youtube';


class Videos extends Component {



    render() {

        const opts = {
            height: '390',
            width: '640',
            playerVars: { // https://developers.google.com/youtube/player_parameters
                autoplay: 0
            }};

        return (
            <Card>
                <Row>

                    <Col s={2} m={2}>
                        <div align={"center"}>
                            <img src={youtube} alt={"Youtube img"} className={"Youtube img"}/> </div>

                    </Col>
                    <Col s={10} m={10}>
                        <h5><b><FormattedMessage id={"videos.text"} defaultMessage={"Canal do AquaSafe no Youtube"}/></b></h5></Col> </Row>

                <Row>
                    <Col s={2} m={2}>

                        {/*ocupando espaço*/}

                    </Col>
                    <Col s={10} m={10}>
                        <p><FormattedMessage id={"videos.text1"} defaultMessage={"Inscreva-se e acompanhe o canal do"}/> <a href={"https://www.youtube.com/channel/UCVlP7kQKH2lz4fILh9XpeRA"}>AquaSafe</a> <FormattedMessage id={"videos.text2"} defaultMessage={"no Youtube!"}/></p></Col>


                </Row>

                <Row>
                    <Col s={2} m={2}>
                        {/*ocupando espaço*/}
                    </Col>

                    <Col s={10} m={10}>


                        <YouTube
                            videoId="6r0GSMMN5nc"
                            opts={opts}


                        />

                    </Col>

                </Row>
            </Card>
        )


    }




}

export default Videos;